import { useMutation, useQuery } from '@tanstack/react-query';

import {
	getVerifyEmailVerificaitonToken,
	getVerifyResetPasswordToken,
	getVerifyResetPasswordTokenAdmin,
	postChangePassword,
	postChangePasswordAdmin,
	postForgotPassword,
	postLogin,
	postLogout,
	postSendEmailVerification,
	postVerifyEmail,
} from '../../api/authApi';

export const usePostLogin = (options) => {
	return useMutation(postLogin, {
		...options,
	});
};

export const usePostLogout = (options) => {
	return useMutation(postLogout, {
		...options,
	});
};

export const usePostSendEmailVerification = (options) => {
	return useMutation(postSendEmailVerification, {
		...options,
	});
};

export const usePostVerifyEmail = (options) => {
	return useMutation(postVerifyEmail, {
		...options,
	});
};

export const useChangePasswordAdmin = (options) => {
	return useMutation(postChangePasswordAdmin, {
		...options,
	});
};

export const useGetVerifyResetPasswordTokenAdmin = (token, options) => {
	return useQuery(['token', { token }], () => getVerifyResetPasswordTokenAdmin(token), {
		...options,
		enabled: !!token,
	});
};

export const usePostForgotPassword = (options) => {
	return useMutation(postForgotPassword, {
		...options,
	});
};

/**
 * User Auth Functions
 */

export const useGetVerifyResetPasswordToken = (token, options) => {
	return useQuery(['token', { token }], () => getVerifyResetPasswordToken(token), {
		...options,
		enabled: !!token,
	});
};

export const useGetVerifyEmailVerificaitonToken = (token, options) => {
	return useQuery(['token', { token }], () => getVerifyEmailVerificaitonToken(token), {
		...options,
		enabled: !!token,
	});
};

export const useChangePassword = (options) => {
	return useMutation(postChangePassword, {
		...options,
	});
};
